import { NALu } from './nalu'
import { ExpGolomb } from '../utils'

export class HEVC {
  static parseHEVCDecoderConfigurationRecord (data) {
    if (data.length < 23) return
    const nalUnitSize = (data[21] & 3) + 1

    let spsParsed
    const spsArr = []
    const ppsArr = []
    const vpsArr = []

    let offset = 23
    const numOfArrays = data[22]

    let nalUnitType
    let numNalus
    let nalSize
    for (let i = 0; i < numOfArrays; i++) {
      nalUnitType = data[offset] & 0x3f
      numNalus = (data[offset + 1] << 8) | data[offset + 2]

      offset += 3

      for (let j = 0; j < numNalus; j++) {
        nalSize = (data[offset] << 8) | data[offset + 1]
        offset += 2
        if (!nalSize) continue
        switch (nalUnitType) {
          case 32:
            vpsArr.push(data.subarray(offset, offset + nalSize))
            break
          case 33: {
            const sps = data.subarray(offset, offset + nalSize)
            if (!spsParsed) spsParsed = HEVC.parseSPS(NALu.removeEPB(sps))
            spsArr.push(sps)
          }
            break
          case 34:
            ppsArr.push(data.subarray(offset, offset + nalSize))
            break
        }

        offset += nalSize
      }
    }

    return {
      sps: spsParsed,
      spsArr,
      ppsArr,
      vpsArr,
      nalUnitSize
    }
  }

  static parseSPS (unit) {
    const eg = new ExpGolomb(unit)
    eg.readUByte()
    eg.readUByte()

    eg.readBits(4)
    const spsMaxSubLayersMinus1 = eg.readBits(3)
    eg.readBits(1)

    const tierLevel = this._parseProfileTierLevel(eg, spsMaxSubLayersMinus1)

    eg.readUEG() // sps_seq_parameter_set_id

    const chromaFormatIdc = eg.readUEG()
    let chromaFormat = 420
    if (chromaFormatIdc <= 3) chromaFormat = [0, 420, 422, 444][chromaFormatIdc]

    let separateColourPlaneFlag = 0
    if (chromaFormatIdc === 3) {
      separateColourPlaneFlag = eg.readBits(1)
    }

    let width = eg.readUEG() // pic_width_in_luma_samples
    let height = eg.readUEG() // pic_height_in_luma_samples

    const conformanceWindowFlag = eg.readBits(1)

    let confWinLeftOffset
    let confWinRightOffset
    let confWinTopOffset
    let confWinBottomOffset
    if (conformanceWindowFlag === 1) {
      confWinLeftOffset = eg.readUEG() // conf_win_left_offset
      confWinRightOffset = eg.readUEG() // conf_win_right_offset
      confWinTopOffset = eg.readUEG() // conf_win_top_offset
      confWinBottomOffset = eg.readUEG() // conf_win_bottom_offset
    }

    const bitDepthLumaMinus8 = eg.readUEG() // bit_depth_luma_minus8
    const bitDepthChromaMinus8 = eg.readUEG() // bit_depth_chroma_minus8

    if (conformanceWindowFlag === 1) {
      const subWidthC = (((chromaFormatIdc === 1) || (chromaFormatIdc === 2)) && (separateColourPlaneFlag === 0)) ? 2 : 1
      const subHeightC = ((chromaFormatIdc === 1) && (separateColourPlaneFlag === 0)) ? 2 : 1
      width -= (subWidthC * (confWinRightOffset + confWinLeftOffset))
      height -= (subHeightC * (confWinBottomOffset + confWinTopOffset))
    }

    return {
      codec: 'hev1.1.6.L93.B0',
      width,
      height,
      chromaFormat,
      bitDepthLumaMinus8,
      bitDepthChromaMinus8,
      generalProfileSpace: tierLevel.generalProfileSpace,
      generalTierFlag: tierLevel.generalTierFlag,
      generalProfileIdc: tierLevel.generalProfileIdc,
      generalLevelIdc: tierLevel.generalLevelIdc
    }
  }

  static _parseProfileTierLevel (eg, maxSubLayersMinus1, profilePresentFlag = 1) {
    let generalProfileSpace
    let generalTierFlag
    let generalProfileIdc

    if (profilePresentFlag) {
      generalProfileSpace = eg.readBits(2)
      generalTierFlag = eg.readBits(1)
      generalProfileIdc = eg.readBits(5)
    }

    eg.readBits(32)

    eg.readBits(1) // general_progressive_source_flag
    eg.readBits(1) // general_interlaced_source_flag
    eg.readBits(1) // general_non_packed_constraint_flag
    eg.readBits(1) // general_frame_only_constraint_flag

    eg.readBits(16)
    eg.readBits(16)
    eg.readBits(12)

    const generalLevelIdc = eg.readUByte()

    const subLayerProfilePresentFlag = []
    const subLayerLevelPresentFlag = []
    for (let j = 0; j < maxSubLayersMinus1; j++) {
      subLayerProfilePresentFlag[j] = eg.readBits(1)
      subLayerLevelPresentFlag[j] = eg.readBits(1)
    }

    if (maxSubLayersMinus1 > 0) {
      eg.readBits((8 - maxSubLayersMinus1) * 2)
    }

    for (let i = 0; i < maxSubLayersMinus1; i++) {
      if (subLayerProfilePresentFlag[i] !== 0) {
        eg.readBits(2)
        eg.readBits(1)
        eg.readBits(5)

        eg.readBits(16)
        eg.readBits(16)

        eg.readBits(4)

        eg.readBits(16)
        eg.readBits(16)
        eg.readBits(12)
      }
      if (subLayerLevelPresentFlag[i] !== 0) {
        eg.readBits(8)
      }
    }

    return {
      generalProfileSpace,
      generalTierFlag,
      generalProfileIdc,
      generalLevelIdc
    }
  }
}
